document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Main product form: variant matching, price, add-to-cart state ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variantIdInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var savingsEl = root.querySelector('[data-savings-badge]');
    var addBtn = root.querySelector('[data-add-to-cart-btn]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var selected = {};

    root.querySelectorAll('[data-option-index]').forEach(function (btn) {
      if (btn.classList.contains('is-selected')) selected[btn.getAttribute('data-option-index')] = btn.getAttribute('data-value');
    });

    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }

    function findVariant() {
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return !selected[i] || selected[i] === val; });
      })[0];
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          if (savingsEl) {
            var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            savingsEl.textContent = 'Save ' + pct + '%';
            savingsEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (savingsEl) savingsEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    root.querySelectorAll('[data-option-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-option-index');
        root.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[idx] = btn.getAttribute('data-value');
        updateUI();
      });
    });

    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyDec = root.querySelector('[data-qty-decrease]');
    var qtyInc = root.querySelector('[data-qty-increase]');
    if (qtyDec) qtyDec.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qtyInc) qtyInc.addEventListener('click', function () { if (qtyInput) qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
  });

  /* ---------- Product gallery: slide switching + swipe ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var galleryId = gallery.getAttribute('data-gallery');
    var thumbs = document.querySelectorAll('[data-gallery-thumb][data-gallery-for="' + galleryId + '"]');
    var current = 0;

    function show(index) {
      if (index < 0 || index >= slides.length) return;
      current = index;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { show(i); });
    });

    var wrap = gallery.querySelector('[data-gallery-main-wrap]');
    if (wrap) {
      var startX = null;
      wrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { show(dx < 0 ? current + 1 : current - 1); }
        startX = null;
      });
    }
  });
});
